"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var _ = require("lodash");
var kfs = require("kiwifruit-solver");
exports.KiwifruitContextElems = React.createContext(undefined);
// Use KiwifruitSolver to set up a solver
var KiwifruitSolver = /** @class */ (function (_super) {
    __extends(KiwifruitSolver, _super);
    function KiwifruitSolver(props) {
        var _this = _super.call(this, props) || this;
        _this.solver = new kfs.Solver();
        _this.state = { animations: {} };
        _this.hasUpdateScheduled = false;
        _this.solver.addListener('change', function () {
            if (!_this.hasUpdateScheduled) {
                _this.hasUpdateScheduled = true;
                requestAnimationFrame(function () {
                    _this.hasUpdateScheduled = false;
                    _this.forceUpdate();
                });
            }
        });
        return _this;
    }
    KiwifruitSolver.prototype.render = function () {
        var children = this.props.children;
        var animations = this.state.animations;
        return React.createElement(exports.KiwifruitContextElems.Provider, { value: { solver: this.solver, animations: animations } }, children);
    };
    return KiwifruitSolver;
}(React.Component));
exports.KiwifruitSolver = KiwifruitSolver;
exports.KiwifruitUser = function (props) {
    return React.createElement(exports.KiwifruitContextElems.Consumer, null, function (kiwifruitContext) {
        if (!kiwifruitContext) {
            throw new Error("Cannot use KiwifruitUser outside of a KiwifruitSolver");
        }
        return React.createElement(KiwifruitUserHelper, __assign({}, props, { kiwifruitContext: kiwifruitContext }));
    });
};
var KiwifruitUserHelper = /** @class */ (function (_super) {
    __extends(KiwifruitUserHelper, _super);
    function KiwifruitUserHelper(props) {
        var _this = _super.call(this, props) || this;
        _this.wrapKiwifruit = function (renderWithTools) {
            return function () {
                _this.variablesRead = {};
                var constraints = [];
                var result = renderWithTools({
                    addConstraint: function () {
                        var newConstraints = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            newConstraints[_i] = arguments[_i];
                        }
                        constraints.push.apply(constraints, newConstraints);
                    },
                    getVariable: function (variableName) {
                        var value = _this.solver.getVariableValue(variableName) || 0;
                        _this.variablesRead[variableName] = value;
                        return value;
                    },
                    id: _this.id
                });
                _this.solver.setConstraints(_this.id, constraints);
                return result;
            };
        };
        // TODO: This assumes kiwifruitContext never changes!
        _this.solver = props.kiwifruitContext.solver;
        _this.id = "interface" + _this.solver.newId();
        _this.variablesRead = {};
        return _this;
    }
    KiwifruitUserHelper.prototype.render = function () {
        if (this.props.renderWithWrapper) {
            return this.props.renderWithWrapper(this.wrapKiwifruit);
        }
        else {
            return this.wrapKiwifruit(this.props.render)();
        }
    };
    KiwifruitUserHelper.prototype.componentWillUnmount = function () {
        this.solver.setConstraints(this.id, []);
    };
    KiwifruitUserHelper.prototype.shouldComponentUpdate = function (nextProps) {
        // The props here come from two sources:
        //   * `render` comes from the wrapped component's owner. It's a callback which ought to be recreated
        //     on every render of the owner. So the `this.props.render !== nextProps.render` check isn't making
        //     any assumptions about purity of the contents of render.
        //  * `kiwifruitContext` comes from the context provider. It changes whenever the Kiwifruit solver
        //    thinks a variable used down in the tree might have changed. Here, we filter it via `variableValueChanged`.
        // In summary: This is a very good `shouldComponentUpdate`.
        return this.props.render !== nextProps.render || this.variableValueChanged();
    };
    KiwifruitUserHelper.prototype.variableValueChanged = function () {
        var _this = this;
        return _.some(this.variablesRead, function (readValue, variableName) {
            var curValue = _this.solver.getVariableValue(variableName);
            var changed = (curValue !== undefined && curValue !== readValue);
            if (changed) {
                // console.log("value tracked by KiwifruitUser changed!", variableName, readValue, "=>", curValue)
            }
            return changed;
        });
    };
    return KiwifruitUserHelper;
}(React.Component));
function propsForRect(getVariable, box) {
    return {
        x: getVariable(box.left),
        y: getVariable(box.top),
        width: getVariable(box.width),
        height: getVariable(box.height),
    };
}
exports.propsFor = {
    rect: propsForRect,
    foreignObject: propsForRect,
    svg: function (getVariable, box) {
        return {
            viewBox: getVariable(box.left) + " " + getVariable(box.top) + " " + getVariable(box.width) + " " + getVariable(box.height),
        };
    },
};
exports.styleFor = {
    div: function (getVariable, box) {
        return {
            position: 'absolute',
            left: getVariable(box.left),
            top: getVariable(box.top),
            width: getVariable(box.width),
            height: getVariable(box.height),
        };
    },
    svg: function (getVariable, box) {
        return {
            position: 'absolute',
            left: getVariable(box.left),
            top: getVariable(box.top),
            width: getVariable(box.width),
            height: getVariable(box.height),
        };
    },
};
var KiwifruitVisualizerBox = /** @class */ (function (_super) {
    __extends(KiwifruitVisualizerBox, _super);
    function KiwifruitVisualizerBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { hovered: false, labelWidth: null };
        _this.ref = React.createRef();
        _this.onBodyMouseMove = function (ev) {
            if (_this.ref.current) {
                var clientX = ev.clientX, clientY = ev.clientY;
                var _a = _this.ref.current.getBoundingClientRect(), left = _a.left, right = _a.right, top_1 = _a.top, bottom = _a.bottom;
                _this.setState({ hovered: left <= clientX && clientX <= right &&
                        top_1 <= clientY && clientY <= bottom });
            }
        };
        return _this;
    }
    KiwifruitVisualizerBox.prototype.render = function () {
        var _this = this;
        var _a = this.props, values = _a.values, boxName = _a.boxName, _b = _a.svg, svg = _b === void 0 ? false : _b;
        var _c = this.state, hovered = _c.hovered, labelWidth = _c.labelWidth;
        if (svg) {
            return (React.createElement("g", null,
                React.createElement("rect", { ref: this.ref, x: values[boxName + '-left'], y: values[boxName + '-top'], width: values[boxName + '-width'], height: values[boxName + '-height'], style: { stroke: 'blue', strokeWidth: hovered ? 4 : 1, fill: 'transparent' } }),
                hovered &&
                    React.createElement(React.Fragment, null,
                        React.createElement("rect", { x: values[boxName + '-left'] + 3, y: values[boxName + '-top'] + 3, width: labelWidth || 0, height: 12, fill: "#ddd" }),
                        React.createElement("text", { ref: function (elem) {
                                if (elem) {
                                    var newLabelWidth = elem.getBoundingClientRect().width;
                                    if (labelWidth !== newLabelWidth) {
                                        _this.setState({ labelWidth: elem.getBoundingClientRect().width });
                                    }
                                }
                            }, x: values[boxName + '-left'] + 3, y: values[boxName + '-top'] + 3, alignmentBaseline: 'hanging', textAnchor: 'left', fill: 'blue', fontFamily: 'monospace', style: { pointerEvents: 'none' } }, boxName))));
        }
        else {
            return (React.createElement("div", { ref: this.ref, style: { position: 'absolute', left: values[boxName + '-left'], top: values[boxName + '-top'],
                    width: values[boxName + '-width'], height: values[boxName + '-height'],
                    borderColor: 'blue', borderStyle: 'solid', borderWidth: hovered ? 4 : 1, padding: hovered ? 1 : 4,
                    display: 'flex', flexDirection: 'column', justifyContent: 'flexStart', alignItems: 'center' } }, hovered &&
                React.createElement("div", { style: { fontFamily: 'monospace', fontSize: 10 } }, boxName)));
        }
    };
    KiwifruitVisualizerBox.prototype.componentDidMount = function () {
        document.body.addEventListener('mousemove', this.onBodyMouseMove);
    };
    KiwifruitVisualizerBox.prototype.componentWillUnmount = function () {
        document.body.removeEventListener('mousemove', this.onBodyMouseMove);
    };
    return KiwifruitVisualizerBox;
}(React.Component));
var KiwifruitVisualizer = /** @class */ (function (_super) {
    __extends(KiwifruitVisualizer, _super);
    function KiwifruitVisualizer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.bodyObserver = null;
        _this.onBodyChange = function () {
            _this.forceUpdate();
        };
        return _this;
    }
    KiwifruitVisualizer.prototype.render = function () {
        var _this = this;
        return React.createElement(exports.KiwifruitContextElems.Consumer, null, function (kiwifruitContext) {
            var _a = _this.props.svg, svg = _a === void 0 ? false : _a;
            var enabled = document.body.classList.contains("KiwifruitVisualizer-enabled");
            if (!enabled) {
                return svg ? React.createElement("g", null) : React.createElement("div", null);
            }
            if (!kiwifruitContext) {
                throw new Error("Cannot use KiwifruitVisualizer outside of a KiwifruitSolver");
            }
            var values = kiwifruitContext.solver.getVariableValues();
            var boxNames = _.compact(_.map(values, function (_value, variableName) {
                var match = variableName.match("(.*)-left$");
                return match ? match[1] : null;
            }));
            var children = boxNames.map(function (boxName) {
                return React.createElement(KiwifruitVisualizerBox, { key: boxName, values: values, boxName: boxName, svg: svg });
            });
            if (svg) {
                return React.createElement("g", { className: "KiwifruitVisualizer", onMouseMove: function (ev) { return _this.setState({ hoverPosition: [ev.clientX, ev.clientY] }); }, onMouseOut: function () { return _this.setState({ hoverPosition: null }); } }, children);
            }
            else {
                return React.createElement("div", { className: "KiwifruitVisualizer", style: { position: "absolute", left: 0, right: 0, top: 0, bottom: 0 }, onMouseMove: function (ev) { return _this.setState({ hoverPosition: [ev.clientX, ev.clientY] }); }, onMouseOut: function () { return _this.setState({ hoverPosition: null }); } }, children);
            }
        });
    };
    KiwifruitVisualizer.prototype.componentDidMount = function () {
        activateHotkey();
        this.bodyObserver = new MutationObserver(this.onBodyChange);
        this.bodyObserver.observe(document.body, { attributes: true });
    };
    KiwifruitVisualizer.prototype.componentWillUnmount = function () {
        if (this.bodyObserver) {
            this.bodyObserver.disconnect();
        }
    };
    return KiwifruitVisualizer;
}(React.Component));
exports.KiwifruitVisualizer = KiwifruitVisualizer;
var hotkeyActivated = false;
function activateHotkey() {
    if (hotkeyActivated) {
        return;
    }
    document.addEventListener('keydown', function (ev) {
        if ((ev.metaKey || ev.ctrlKey) && ev.key === "i") {
            document.body.classList.toggle('KiwifruitVisualizer-enabled');
            ev.stopImmediatePropagation();
        }
    });
    hotkeyActivated = true;
}
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../kiwifruit/kiwifruit-react/build/index.js
// module id = 22
// module chunks = 0